const text = (value) => String(value ?? "").trim();

export const mapFaq = (dto) => ({
  id: dto?.id,
  question: text(dto?.question),
  answer: text(dto?.answer),
  position: dto?.position == null ? Number.MAX_SAFE_INTEGER : Number(dto.position),
});

export const mapFaqs = (rows) =>
  (rows || [])
    .filter((row) => row && row.active !== false)
    .map(mapFaq)
    .filter((faq) => faq.id != null && faq.question !== "")
    .sort((a, b) => a.position - b.position);
